module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isOpen),
      expression: "isOpen"
    }],
    staticClass: "uploads__list upload-progress"
  }, [_c('button', {
    staticClass: "button hide",
    on: {
      "click": _vm.onHideClicked
    }
  }, [_c('i', {
    staticClass: "fa fa-times",
    attrs: {
      "aria-hidden": "true"
    }
  })]), _vm._v(" "), _c('h3', {
    staticClass: "upload-progress__header"
  }, [_vm._v("Current uploads")]), _vm._v(" "), (_vm.uploads.length) ? _vm._l((_vm.uploads), function(upload) {
    return _c('ProgressBar', {
      key: upload.id,
      attrs: {
        "file-name": upload.fileName,
        "progress": upload.fileProgress,
        "status": upload.status
      },
      on: {
        "stop-clicked": function($event) {
          return _vm.onStopUploadClicked($event, upload.id)
        },
        "resume-clicked": function($event) {
          return _vm.onResumeUploadClicked($event, upload.id)
        },
        "pause-clicked": function($event) {
          return _vm.onPauseUploadClicked($event, upload.id)
        },
        "retry-clicked": function($event) {
          return _vm.onRetryUploadClicked($event, upload.id)
        },
        "remove-clicked": function($event) {
          return _vm.onRemoveClicked($event, upload.id)
        }
      }
    })
  }) : _c('p', {
    staticClass: "upload-progress__no-uploads"
  }, [_vm._v("No uploading files")])], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-744cc616","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/uploadManager/UploadsList.vue
// module id = 943
// module chunks = 0